module.exports = __webpack_public_path__ + "img/report-border.682c9aa1.png";